/* eslint-disable react-hooks/rules-of-hooks */
import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { Card, CardActions } from '@material-ui/core';
import Tabs, { TabPane } from 'rc-tabs';
import DeviceLog from '../deviceLogs/DeviceLog';
import Locations from '../locations/Locations';
import Events from '../Events/Events';
import Battery from '../battery/Battery';
import { VictimDashboard } from '../dashboard/victimDashboard';
import './victimManagement.scss';
import VictimDebug from '../victimdebug/VictimDebug';
import { VictimAccountSettings } from '../victimAccountSettings/accountSettings';


function victimManagement({search, setSearch, locations, setLocations, jwt, ...props}) {
  const [tabKey, setTabKey] = useState('0');
  const [tabPanes, setTabPanes] = useState([]);

  useEffect(()=> {
    setTabKey('0');
  }, [props.currentDevice.deviceId]);
  useEffect(()=> {
    let tabs = [];
    if(jwt.permissions.includes(706))
      tabs.push(
        <TabPane key={tabs.length} tab="Dashboard">
          <VictimDashboard currentDevice={props.currentDevice} />
        </TabPane>);
    if(jwt.permissions.includes(22))
      tabs.push(
        <TabPane key={tabs.length} tab="Debug">
          <VictimDebug search={search} setsearch={setSearch} locations={locations} setLocations={setLocations} />
        </TabPane>);
    if(jwt.permissions.includes(22))
      tabs.push(
        <TabPane key={tabs.length} tab="Account">
          <VictimAccountSettings currentDevice={props.currentDevice} />
        </TabPane>);
    if(jwt.permissions.includes(22))
      tabs.push(
        <TabPane key={tabs.length} tab="Logs">
          <DeviceLog search={search} setsearch={setSearch} locations={locations} setLocations={setLocations} productType={'victim'} />
        </TabPane>);
    if(jwt.permissions.includes(22))
      tabs.push(
        <TabPane key={tabs.length} tab="Locations">
          <DeviceLog search={search} setsearch={setSearch} locations={locations} setLocations={setLocations} mapDisplay={true} productType={'victim'} />
        </TabPane>);
    if(jwt.permissions.includes(22))
      tabs.push(
        <TabPane key={tabs.length} tab="Tracking Gaps">
          <Locations search={search} setsearch={setSearch} locations={locations} setLocations={setLocations} productType={'victim'} />
        </TabPane>);
    if(jwt.permissions.includes(706))
      tabs.push(
        <TabPane key={tabs.length} tab="Battery">
          <Battery search={search} setsearch={setSearch} productType={'victim'} />
        </TabPane>);
    if(jwt.permissions.includes(747))
      tabs.push(
        <TabPane key={tabs.length} tab="Events">
          <Events search={search} setsearch={setSearch} productType={'victim'} />
        </TabPane>);
    setTabPanes(tabs);
  }, [jwt, locations, props.currentDevice, search, setLocations, setSearch]);

  function tabChange(e) {
    setTabKey(e);
  }

  return (
    <Card className='VictimManagement'>
      <CardActions>
          <Tabs
            defaultActiveKey="0"
            activeKey={tabKey}
            destroyInactiveTabPane={true}
            tabBarGutter={5}
            onTabClick={tabChange}
            animated={{tabPane: true, inkBar: true}}
            moreIcon="..."
            style={{maxWidth: '100%', flex: '1 1 auto'}}
            tabBarStyle={{backgroundColor: 'whitesmoke'}}
          >
            {tabPanes}
          </Tabs>
      </CardActions>
    </Card>
  );
}
const mapStateToProps = state => ({
  jwt: state.security.jwt,
});

export const VictimManagement = connect(mapStateToProps)(victimManagement);